import { useEffect, useRef, useState, useCallback } from "react";
import {
  MotifButton,
  MotifInput,
  MotifTable,
  MotifLabel,
  MotifFormField,
  MotifOption,
  MotifSelect,
  MotifErrorMessage,
  MotifToast,
} from "@ey-xd/motif-react";
import { TableHeader } from "./tableHeader";
import { useNavigate } from "react-router-dom";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogContent from "@mui/material/DialogContent";
import { getAccount } from "../../common/services/commonService";
import useLogin from "../../common/redux/common/login/useLogin";
import { ROLES, PARTNER, USER, ADMIN, OWNER  } from "../../common/contants/constants";
import { getLoginDetail } from "../../common/redux/common/login/loginSlice";
import { useDispatch } from "react-redux";
import { ApiStatus } from "../../common/services/api-status.enum";
import { getAdminUsersData, getAddAdminGroupUserData, getAllUsersData, getUserHistoryData, getEditUserData, getDeleteUserData, getAddUserData, getDeleteAdminGroupUserData, getUsersRolesData, getPlannedOutageUsersData, getAddPlannedOutageUserData, getDeletePlannedOutageUserData } from "./redux/userManagementSlice";
import useUsermanagement from "./hooks/useUsermanagement";

import "./userManagement.scss";
import logger from "../../common/utils/logger";

export const UserManagement = () => {
  const [searchValue, setSearchValue] = useState("");
  const [userData, setUserData] = useState([]);
  const [userHistoryData, setUserHistoryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setModalOpen] = useState(null);
  const [activeTab, setActiveTab] = useState("activeUsers");
  const [isActive, setIsActive] = useState("");
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [userRoleId, setUserRoleId] = useState("");
  const [deleteUserRole, setDeleteUserRole] = useState("");
  const [userId, setUserId] = useState("");
  const [lastModifiedBy, setLastModifiedBy] = useState("");
  const [deleteDescription, setdeleteDescription] = useState("");
  const [accessTypeList, setAccessTypeList] = useState("");
  const [showSuccessAddToast, setShowSuccessAddToast] = useState(false);
  const [showSuccessEditToast, setShowSuccessEditToast] = useState(false);
  const [showExistingUserToast, setShowExistingUserToast] = useState(false);
  const [showSuccessDeleteToast, setShowSuccessDeleteToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [wordCount, setWordCount] = useState(0);
  const [hasRecords, setHasRecords] = useState(false);
  const [selectedRow, setSelectedRow] = useState(0);
  const [userRole, setUserRole] = useState(USER); // Default role
  const [UserExist, setExistingUser] = useState(false);
  const [adminData, setAdminData] = useState([]);
  const [isMemberModalOpen, setMemberModalOpen] = useState(false);
  const [deploymentTeamData, setDeploymentTeamData] = useState([]);
  const {loginDetail, loading, error}  = useLogin();
  const dispatch = useDispatch();
  const { adminGroupUsersData, addAdminGroupUserData, allUsersData, usersHistoryData, editUserData, deleteUserData, addUserData, deleteAdminGroupUserData, usersRolesData, plannedOutageUsersData, addPlannedOutageUserData, deletePlannedOutageUserData } = useUsermanagement();

const getAdminData = () => {
  dispatch(getAdminUsersData());
};

useEffect(() => {
  if(adminGroupUsersData?.status === ApiStatus.SUCCESS){
    setAdminData(adminGroupUsersData?.data || []);
  } else if(adminGroupUsersData?.status === ApiStatus.ERROR){
    logger.error("An error occurred:", adminGroupUsersData?.error);
  }
}, [adminGroupUsersData?.status, adminGroupUsersData?.error]);

const getDeploymentTeamData = () => {
  dispatch(getPlannedOutageUsersData());
};

useEffect(() => {
  if (plannedOutageUsersData?.status === ApiStatus.SUCCESS) {
    const mappedData = (plannedOutageUsersData?.data || []).map((user) => ({
      userId: user?.id,
      userName: user?.userName,
      email: user?.userEmail,
      userRole: user?.userRole || "",
      isEnabled: user?.isEnabled,
      lastModifiedDt: user?.lastModifiedAtUtc || user?.createdAtUtc,
      lastModifiedBy: user?.lastModifiedBy || user?.createdBy,
    }));
    setDeploymentTeamData(mappedData);
  } else if (plannedOutageUsersData?.status === ApiStatus.ERROR) {
    logger.error("An error occurred:", plannedOutageUsersData?.error);
  }
}, [plannedOutageUsersData?.status, plannedOutageUsersData?.error]);

  const handleOpenAdminModal = () => {
    setModalOpen(true);
    setEmail("");
    setUserName("");
    setUserRoleId("");
    setExistingUser(false);
  };

  const onAddAdminClick = () => {
    setIsLoading(true);
    dispatch(getAddAdminGroupUserData({
      userRole: userRoleId,
      userName: userName,
      email: email,
      createdBy: getAccount()?.username,
      lastModifiedBy: getAccount()?.name
    }));
  };

// Call getAdminData when the component mounts
useEffect(() => {
  getAdminData();
  getDeploymentTeamData();
}, []);

useEffect(() => {
  if (!isModalOpen) return; // Only run when modal is open (i.e., after onAddAdminClick)
  if(addAdminGroupUserData?.status === ApiStatus.SUCCESS){
    setIsLoading(false);
        setModalOpen(false);
        setShowSuccessAddToast(true); // Show the success toast
        setTimeout(() => setShowSuccessAddToast(false), 3000); // Hide the toast after 3 seconds
        if(email===getAccount()?.username)
        window.location.reload();
        getAdminData();
} else if(addAdminGroupUserData?.status === ApiStatus.ERROR){
  setIsLoading(false);
        setShowErrorToast(true); // Show the error toast
        setTimeout(() => setShowErrorToast(false), 3000); // Hide the toast after 3 seconds
        logger.error("An error occurred:", addAdminGroupUserData?.error);
}
}, [addAdminGroupUserData?.status, addAdminGroupUserData?.error]);



  const handleOpenModal = () => {
    setModalOpen(true);
    setEmail("");
    setUserName("");
    setUserRoleId("");
    setExistingUser(false);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setUserName("");
    setUserRoleId("");
    setEmail("");
    setExistingUser(false);
  };

  const handleOpenMemberModal = () => {
    setMemberModalOpen(true);
    setEmail("");
    setUserName("");
    setUserRoleId("");
    setExistingUser(false);
  };

  const handleCloseMemberModal = () => {
    setMemberModalOpen(false);
    setUserName("");
    setUserRoleId("");
    setEmail("");
    setExistingUser(false);
  };

  const onAddMemberClick = () => {
    const memberExists = deploymentTeamData.some(
      (member) => member.email?.toLowerCase() === email.toLowerCase()
    );
    if (memberExists) {
      logger.error("User ID already exists.");
      setShowExistingUserToast(true);
      setTimeout(() => setShowExistingUserToast(false), 3000);
      setMemberModalOpen(false);
      return;
    }
    setIsLoading(true);
    dispatch(
      getAddPlannedOutageUserData({
        userEmail: email,
        username: userName,
      })
    );
  };

  useEffect(() => {
    if (!isMemberModalOpen && addPlannedOutageUserData?.status !== ApiStatus.SUCCESS) return;
    if (addPlannedOutageUserData?.status === ApiStatus.SUCCESS) {
      setIsLoading(false);
      setMemberModalOpen(false);
      setShowSuccessAddToast(true);
      setTimeout(() => setShowSuccessAddToast(false), 3000);
      getDeploymentTeamData();
    } else if (addPlannedOutageUserData?.status === ApiStatus.ERROR) {
      setIsLoading(false);
      setShowErrorToast(true);
      setTimeout(() => setShowErrorToast(false), 3000);
      logger.error("An error occurred:", addPlannedOutageUserData?.error);
    }
  }, [addPlannedOutageUserData?.status, addPlannedOutageUserData?.error]);

  const handleSubmit = (event) => {
    event.preventDefault();
  };


  //ActiveUSers
  const viewActiveUsers = Object.values(
    userData?.filter((item) => {
      // Check if the item is active
      const isActive = item?.isActive === true;

      const matchesUserName = item?.userName
        ?.toLowerCase()
        .includes(searchValue.toLowerCase());
      // Return true if the item is active and matches the search
      const matchesEmail = item?.email
        ?.toLowerCase()
        .includes(searchValue.toLowerCase());

      const matchesRole = item?.userRole
        ?.toLowerCase()
        .includes(searchValue.toLowerCase());

      return (
        (isActive && matchesUserName) ||
        (isActive && matchesEmail) ||
        (isActive && matchesRole)
      );
    })
  );
  //All Records
  const viewAllRecords = Object.values(
    userHistoryData?.filter((item) => {
      // Check if the item is active
      const matchesUserName = item.userName
        ?.toLowerCase()
        .includes(searchValue.toLowerCase());
      // Return true if the item is active and matches the search
      const matchesEmail = item.email
        ?.toLowerCase()
        .includes(searchValue.toLowerCase());

      const matchesRole = item.userRole
        ?.toLowerCase()
        .includes(searchValue.toLowerCase());

      return matchesUserName || matchesEmail || matchesRole;
    })
  );

    const viewAdminRecords = Object.values(
    adminData?.filter((item) => {
      // Check if the item is active
      const matchesUserName = item.userName
        ?.toLowerCase()
        .includes(searchValue.toLowerCase());
      // Return true if the item is active and matches the search
      const matchesEmail = item.email
        ?.toLowerCase()
        .includes(searchValue.toLowerCase());

      const matchesRole = item.userRole
        ?.toLowerCase()
        .includes(searchValue.toLowerCase());

      return matchesUserName || matchesEmail || matchesRole;
    })
  );

  //Deployment Team
  const viewDeploymentTeamRecords = Object.values(
    deploymentTeamData?.filter((item) => {
      const matchesUserName = item.userName
        ?.toLowerCase()
        .includes(searchValue.toLowerCase());
      const matchesEmail = item.email
        ?.toLowerCase()
        .includes(searchValue.toLowerCase());
      const matchesRole = item.userRole
        ?.toLowerCase()
        .includes(searchValue.toLowerCase());

      return matchesUserName || matchesEmail || matchesRole;
    })
  );

  const onDeploymentDeleteClick = (value) => {
    const rowData = deploymentTeamData?.filter(
      (row) => row.userId === value?.data?.userId
    );
    setSelectedRow(rowData[0]);
    setUserId(rowData[0]?.userId);
    setEmail(rowData[0]?.email);
    setUserName(rowData[0]?.userName);
    setDeleteUserRole(rowData[0]?.userRole);
    setdeleteDescription("");
    setIsDeleteModalOpen(true);
  };

  const onConfirmDeploymentDeleteClick = () => {
    setIsDeleteModalOpen(false);
    setIsLoading(true);
    dispatch(getDeletePlannedOutageUserData({ id: userId }));
  };

  useEffect(() => {
    if (deletePlannedOutageUserData?.status === ApiStatus.SUCCESS) {
      setIsLoading(false);
      setShowSuccessDeleteToast(true);
      setTimeout(() => setShowSuccessDeleteToast(false), 3000);
      getDeploymentTeamData();
    } else if (deletePlannedOutageUserData?.status === ApiStatus.ERROR) {
      setIsLoading(false);
      setShowErrorToast(true);
      setTimeout(() => setShowErrorToast(false), 3000);
      logger.error("An error occurred:", deletePlannedOutageUserData?.error);
    }
  }, [deletePlannedOutageUserData?.status, deletePlannedOutageUserData?.error]);

  const onUserNameClick = (event) => {
    const trimmedValue = event.target.value.replace(/^\s+/, "");
    setUserName(trimmedValue);
  };
  const onEmailChange = (event) => {
    const trimmedValue = event.target.value.replace(/^\s+/, "");
    setEmail(trimmedValue);
    checkUserRecordExist(trimmedValue);

  };
  const checkUserRecordExist = (email) => {
    const user = userData.find((user) => user?.email?.toLowerCase() === email.toLowerCase());
    if(user?.userName){
    setExistingUser(true);
    setUserName(user.userName);
    }
    else {
      setExistingUser(false);
      setUserName("");
    
    }
  };

  const wordLimit = 2000;
  const onDeleteDescriptionClick = (event) => {
    const trimmedValue = event.target.value.replace(/^\s+/, "");
    setdeleteDescription(trimmedValue);
    const wordCount = trimmedValue.length;

    //Checking Word Count for Desciption Box
    setWordCount(wordCount);
    if (wordCount > wordLimit) {
      const trimmedText = trimmedValue.substring(0, wordLimit);
      setdeleteDescription(trimmedText);
      setWordCount(wordLimit);
    }
  };
  const onUserRoleIdClick = (selectedValue) => {
    setUserRoleId(selectedValue);
  };
  

  useEffect(() => {
    getData();
    getHistoryData();
    getRole();
     const intervalId = setInterval(getData, 90000);
     return () => clearInterval(intervalId);
  }, []);

  // useEffect(() => {
  //   // Fetch the role when the component mounts
  //   getRole().then(fetchedRole => {
  //     setUserRole(fetchedRole);
  //   });
  // }, []);

const getRole = useCallback(() => {
  const account = getAccount();
  const payload = {
    userName: account?.name,
    emailId: account?.username,
  };
  if (account?.username) {
    dispatch(getLoginDetail(payload));
  }
}, [dispatch]);

useEffect(() => {
  
  if (loginDetail?.status === ApiStatus.SUCCESS) {
    const userRole = loginDetail?.data.userRole === "" ? "User" : loginDetail?.data.userRole;
    setUserRole(userRole); // Set the user role state
  } else if (loginDetail?.status === ApiStatus.ERROR) {
    logger.error(error);
    setUserRole("User"); // Set the default role
  }
  
}, [error, loginDetail?.data.userRole, loginDetail?.status]);
  // const getRole = useCallback(() => {
  //   try {
  //     const userRole = loginDetail?.userRole === "" ? USER : loginDetail?.userRole;
  //     return Promise.resolve(userRole);
  //   } catch (error) {
  //     console.error(error);
  //     return Promise.resolve(USER);
  //   }
  // }, [loginDetail]);

useEffect(() => {
    const fetchRoles = async () => {
        if (loginDetail?.status === ApiStatus.SUCCESS) {
            if (activeTab === "admins") {
                // Hardcode the roles for admins
                setAccessTypeList(ROLES);
            } else {
                  dispatch(getUsersRolesData());
            }
        }
    };

    fetchRoles();
}, [activeTab, loginDetail]);

useEffect(() => {
  if(usersRolesData?.status === ApiStatus.SUCCESS){
// If the fetched user role is "Admin", filter the roles
               const roles = usersRolesData?.data.filter(role => role.roleName === ADMIN || role.roleName === PARTNER);
                    setAccessTypeList(roles);
  } else if(usersRolesData?.status === ApiStatus.ERROR){
    logger.error("An error occurred while fetching roles:", usersRolesData?.error);
    if (usersRolesData?.error && usersRolesData?.error.includes("401")) {
                        navigation("/");
                    }
  }
}, [usersRolesData?.status]);
  const gridRef = useRef();
  const navigation = useNavigate();

  const onFilterTextBoxChanged = (value) => {
    setSearchValue(value);
  };

  const onAddUserClick = () => {
    const activeUserExists = userData.some((user) => user.email === email && user.isActive);
    const activeAdminUserExists = adminData.some((user) => user.email === email);

 if(activeTab === "admins" )
{
 if( activeAdminUserExists)
    {  logger.error("User ID already exists.");
      setShowExistingUserToast(true);
      setTimeout(() => setShowExistingUserToast(false), 3000);
      setModalOpen(false);
      // Optionally, set isLoading to false if you had set it to true earlier
      setIsLoading(false);
      return;
    }
    else 
    {
       onAddAdminClick();
    }
} 
   else 
    { 
      if (activeUserExists ) {
      logger.error("User ID already exists.");
      setShowExistingUserToast(true);
      setTimeout(() => setShowExistingUserToast(false), 3000);
      setModalOpen(false);
      // Optionally, set isLoading to false if you had set it to true earlier
      setIsLoading(false);
      return;
    }  else {
      setIsLoading(true);
      dispatch(getAddUserData({
        userRoleId: userRoleId,
          userName: userName,
          email: email,
          createdBy: getAccount()?.username,
          lastModifiedBy: getAccount()?.name
      }));
    }
  }
  };

  useEffect(() => {
    if (isModalOpen === null) return;
    if(addUserData?.status === ApiStatus.LOADING){
    setModalOpen(false);
    setIsLoading(true);
  }
    if(addUserData?.status === ApiStatus.SUCCESS){
      setIsEditModalOpen(false);
          setModalOpen(false);
          setIsLoading(false);
          setShowSuccessAddToast(true); // Show the success toast
          setTimeout(() => setShowSuccessAddToast(false), 3000); // Hide the toast after 3 seconds
          if(email===getAccount()?.username){
            getRole();
          }
          getData();
          getHistoryData();
  } else if(addUserData?.status === ApiStatus.ERROR){
    setIsLoading(false);
          setShowErrorToast(true); // Show the error toast
          setTimeout(() => setShowErrorToast(false), 3000); // Hide the toast after 3 seconds
          if (addUserData?.error?.includes("401")) {
        navigation("/");
      } else {
        logger.error("An error occurred:", addUserData?.error);
      }
  }
  }, [addUserData?.status, addUserData?.error]);
  const onConfirmEditClick = () => {
    setIsLoading(true);
    dispatch(getEditUserData({userId: userId,
        userName: userName,
        email: email,
        userRoleId: userRoleId,
        isActive: isActive,
        lastModifiedBy: getAccount()?.name}));
  };

useEffect(() => {
  if (!isEditModalOpen) return; // Only run when edit modal is open (i.e., after onConfirmEditClick)
  if (editUserData?.status === ApiStatus.SUCCESS) {
    setIsEditModalOpen(false);
    setModalOpen(false);
    setIsLoading(false);
    setShowSuccessEditToast(true); // Show the success toast
    setTimeout(() => {
      setShowSuccessEditToast(false);
      getData();
    }, 3000); // Hide the toast after 3 seconds and reload after toast
    if (getAccount()?.username === email) {
      getRole();
    }
  } else if (editUserData?.status === ApiStatus.ERROR) {
    setIsLoading(false);
    setShowErrorToast(true); // Show the error toast
    setTimeout(() => setShowErrorToast(false), 3000); // Hide the toast after 3 seconds
    if (editUserData?.error?.includes("401")) {
      navigation("/");
    } else {
      logger.error("An error occurred:", editUserData?.error);
    }
  }
}, [editUserData?.status, editUserData?.error]);
  const onConfirmDeleteClick = () => {
    setIsLoading(true);
    dispatch(getDeleteUserData({userId: userId,
          userName: getAccount()?.username,
          deleteDescription: deleteDescription,
          email:email}));
  };
  useEffect(() => {
    if (isDeleteModalOpen === null) return; // Only run when delete modal is open (i.e., after onConfirmDeleteClick)
    if(deleteUserData?.status === ApiStatus.LOADING){
    setIsDeleteModalOpen(false);
    setIsLoading(true);
  }
    if (deleteUserData?.status === ApiStatus.SUCCESS) {
      setIsDeleteModalOpen(false);
      setModalOpen(false);
      setIsLoading(false);
      setShowSuccessDeleteToast(true); // Show the success toast
      setTimeout(() => setShowSuccessDeleteToast(false), 3000); // Hide the toast after 3 seconds
      getData();
    } else if (deleteUserData?.status === ApiStatus.ERROR) {
      setIsLoading(false);
      setShowErrorToast(true); // Show the error toast
      setTimeout(() => setShowErrorToast(false), 3000); // Hide the toast after 3 seconds
      if (deleteUserData?.error?.includes("401")) {
        navigation("/");
      } else {
        logger.error("An error occurred:", deleteUserData?.error);
      }
    }
  }, [deleteUserData?.status, deleteUserData?.error]);

  const onConfirmAdminDeleteClick = () => {
    setIsLoading(true);
    dispatch(getDeleteAdminGroupUserData({
      Email: email,
      lastModifiedBy: getAccount()?.name,
      userRole: deleteUserRole,
          comments: deleteDescription,
        
      }));
  };
  useEffect(() => {
    if (isDeleteModalOpen === null) return; // Only run when delete modal is open (i.e., after onConfirmDeleteClick)
    if(deleteAdminGroupUserData?.status === ApiStatus.LOADING){
    setIsDeleteModalOpen(false);
    setIsLoading(true);
  }
    if (deleteAdminGroupUserData?.status === ApiStatus.SUCCESS) {
      setIsDeleteModalOpen(false);
      setModalOpen(false);
      setIsLoading(false);
      setShowSuccessDeleteToast(true); // Show the success toast
      setTimeout(() => setShowSuccessDeleteToast(false), 3000); // Hide the toast after 3 seconds
      getAdminData();
    } else if (deleteAdminGroupUserData?.status === ApiStatus.ERROR) {
      setIsLoading(false);
      setShowErrorToast(true); // Show the error toast
      setTimeout(() => setShowErrorToast(false), 3000); // Hide the toast after 3 seconds
      if (deleteAdminGroupUserData?.error?.includes("401")) {
        navigation("/");
      } else {
        logger.error("An error occurred:", deleteAdminGroupUserData?.error);
      }
    }
  }, [deleteAdminGroupUserData?.status, deleteAdminGroupUserData?.error]);

  const onEditModalClose = () => {
    setIsEditModalOpen(false);
  };
  const onDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
    setdeleteDescription("");
  };

  const onModalClose = () => {
    setShowModal(false);
  };

  const onEditClick = (id) => {
    const rowData = userData?.filter((row) => {
      return (
        row.userId === id.data.userId
      )
    })
    setSelectedRow(rowData[0]);
    setUserName(rowData[0]?.userName);
    setEmail(rowData[0]?.email);
    setUserId(rowData[0]?.userId);
    setIsActive(rowData[0]?.isActive);
    setLastModifiedBy(rowData[0]?.lastModifiedBy);
    setUserRoleId(rowData[0]?.roleId);
    setIsEditModalOpen(true);
  };

  const onDeleteClick = (id) => {
    let rowData;
    if(activeTab === "admins")
    {
       rowData = adminData?.filter((row) => {
      return (
        row.email === id.data.email
      )
    })
    }
    else{
     rowData = userData?.filter((row) => {
      return (
        row.userId === id.data.userId
      )
    })
  }
    setSelectedRow(rowData[0]);
    setUserId(rowData[0]?.userId);
    setEmail(rowData[0]?.email)
    setUserName(rowData[0]?.userName);
    setDeleteUserRole(rowData[0]?.userRole)
    setLastModifiedBy(rowData[0]?.lastModifiedBy);
    setdeleteDescription("");
    setIsDeleteModalOpen(true);
  };
  
  const LastModifiedCellRenderer = ({ data }) => {
    const formattedDate = formatLastModifiedDate(data?.lastModifiedDt);
    const lastModifiedBy = data?.lastModifiedBy;
  
    return (
      <div>
        {formattedDate}
        <br />
        <small>Modified by: {lastModifiedBy}</small>
      </div>
    );
  };
  const LastLoginCellRenderer = ({ data }) => {
    // Check if the user is logged out
    if (data?.isUserLogout && data?.lastLoginDate=="0 s") {
      // Format the lastLoginDate as needed. For example, using toLocaleString():
      return <span className="center-text">---</span>;
    } 
    else if (data?.isUserLogout) {
      // Format the lastLoginDate as needed. For example, using toLocaleString():
      const lastLoginDate = data?.lastLoginDate;
      return <span className="center-text">{lastLoginDate} ago</span>;
    }
      else {
      // User is not logged out, display "Online"
      return (
        <div>
          <span className="online-status">•	Online</span>
        </div>
      );
    }
  };
  const endDateCellRenderer = (params) => {
    //Data Recieved is in Desc order for History Id and Asc Order for UserName
    //First Record will be the present Record
    //End Date will be present for that Record
    const userId = params.data.userId;
  
    const userRecords = userHistoryData.filter(record => record.userId === userId);
  
    // Check if the current record is the first one for this user
    if (userRecords.length > 1 && userRecords[0] === params.data && userRecords[0].isActive ) {
      return 'Present';
    } else if (userRecords.length === 1 && userRecords[0].isActive) {
      // Only one record for this user
      return 'Present';
    } else {
      // Not the first record, display the end date
      return formatStartDate(params.value); // Assuming formatStartDate is a function to format the date
    }
  };
  const CustomCellRenderer = ({ value, data }) => {
    const isUserActive = data?.isActive;
  
    const inactiveStyle = {
      color: '#a9a9a9' // This is a dull gray color, you can adjust it as needed
    };
  
    // Apply the inactive style if the user is not active
    const cellStyle = !isUserActive ? inactiveStyle : {};
  
    return (
      <div style={cellStyle}>
        {value}
      </div>
    );
  };
  
  // date formatter function
  function formatLastModifiedDate(dateString) {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options); 
  }
  function formatStartDate(dateString) {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return date.toLocaleDateString('en-US', options); // 
  }
  

  const actionCellRenderer = (value) => {
    const rowData = userData?.filter((row) => {
      return (
        row.userId === value.data.userId
      )
    })

    const renderIcons = () => {
      {
       return (
    <>
      {
        (activeTab === "admins") ? null : // Hide icons if active tab is "admins"
        (userRole === PARTNER || userRole === USER || (userRole && rowData[0]?.userRole === OWNER)) ?
          <div className="edit-icon-disabled">
            <img
              loading="lazy"
              src={require("../../common/images/Button.png")}
              alt="edit-enable-icon"
            />
          </div>
          :
          <div
            className="edit-icon"
            title="Edit User Access"
            onClick={() => onEditClick(value)}
          >
            <img
              loading="lazy"
              src={require("../../common/images/Button.png")}
              alt="edit-enable-icon"
            />
          </div>
      }
      {
        (userRole === PARTNER || userRole === USER || (userRole && rowData[0]?.userRole === OWNER)) ?
          <div className="edit-icon-disabled">
            <img
              loading="lazy"
              src={require("../../common/images/Dropdown.png")}
              alt="edit-enable-icon"
            />
          </div>
          :
          <div
            className="edit-icon"
            title="Delete User Details"
            onClick={() => onDeleteClick(value)}
          >
            <img
              loading="lazy"
              src={require("../../common/images/Dropdown.png")}
              alt="edit-enable-icon"
            />
          </div>
      }
    </>
  );
      }
    };

    return <div className="actions">{renderIcons()}</div>;
  };

  const getData = () => {
     setIsLoading(true);
     dispatch(getAllUsersData());
  };
  useEffect(() => {
    if(allUsersData?.status === ApiStatus.SUCCESS){
      setUserData(allUsersData?.data || []);
       setIsLoading(false);
    } else if(allUsersData?.status === ApiStatus.ERROR){
      if (allUsersData?.error && allUsersData?.status === ApiStatus.ERROR) {
        navigation("/");
      } else {
        logger.error("An error occurred:", allUsersData?.error);
        setHasRecords(false);
      }
    }
  }, [allUsersData?.status, allUsersData?.error]);

  const getHistoryData = () => {
    dispatch(getUserHistoryData());
  };

  useEffect(() => {
    if(usersHistoryData?.status === ApiStatus.SUCCESS){
      setUserHistoryData(usersHistoryData?.data || []);
    } else if(usersHistoryData?.status === ApiStatus.ERROR){
      if (usersHistoryData?.error && usersHistoryData?.status === ApiStatus.ERROR) {
        navigation("/");
      } else {
        logger.error("An error occurred:", userHistoryData?.error);
      }
    }
  }, [usersHistoryData?.status, usersHistoryData?.error]);


  const columnDefs = [
    {
      field: "userName",
      headerName: "User name",
      width: 180
    },
    {
      field: "email",
      headerName: "Email address",
      width: 280
    },
    {
    //  cellRenderer: dotCellRenderer,
      field: "userRole",
      headerName: "User Role",
      width: 180
    },
    {
      cellRenderer: LastModifiedCellRenderer,
      headerName: "Last Modified",
      width: 250
    },
    {
      cellRenderer: LastLoginCellRenderer,
      field: "lastLogin",
      headerName: "Last Login",
      width: 180
    },
    {
      cellRenderer: actionCellRenderer,
      field: "controlid",
      headerName: "",
      width: 150
    },
  ];

  const ViewRecordcolumnDefs = [
    {
      cellRenderer: CustomCellRenderer,
      field: "userName",
      headerName: "User name",
      width: 230
    },
    {
      cellRenderer: CustomCellRenderer,
      field: "email",
      headerName: "Email address",
      width: 280
    },
    {
      cellRenderer: CustomCellRenderer,
      field: "role",
      headerName: "User Role",
      width: 210
    },
    {
      cellRenderer: (params) => <CustomCellRenderer {...params} value={formatStartDate(params.value)} />,
      field: "actionDate",
      headerName: "Start Date",
      width: 240
    },
    {
      cellRenderer: (params) => <CustomCellRenderer {...params} value={endDateCellRenderer(params)} />,
      field: "endDate",
      headerName: "End Date",
      width: 260
    },
  ];

    const adminColumnDefs = [
    {
      field: "userName",
      headerName: "User name",
      width: 250
    },
    {
      field: "email",
      headerName: "Email address",
      width: 340
    },
    {
      field: "userRole",
      headerName: "User Role",
      width: 220
    },
    {
      cellRenderer: LastModifiedCellRenderer,
      headerName: "Last Modified",
      width: 300
    },
    {
      cellRenderer: actionCellRenderer,
      field: "controlid",
      headerName: "",
      width: 110
    },
  ];

  const deploymentActionCellRenderer = (value) => {
    return (
      <div className="actions">
        <div
          className="edit-icon"
          title="Delete Member"
          onClick={() => onDeploymentDeleteClick(value)}
        >
          <img
            loading="lazy"
            src={require("../../common/images/Dropdown.png")}
            alt="delete-member-icon"
          />
        </div>
      </div>
    );
  };

  const deploymentColumnDefs = [
    {
      field: "userName",
      headerName: "User name",
      width: 250
    },
    {
      field: "email",
      headerName: "Email address",
      width: 340
    },
    {
      field: "userRole",
      headerName: "User Role",
      width: 220
    },
    {
      cellRenderer: LastModifiedCellRenderer,
      headerName: "Last Modified",
      width: 300
    },
    {
      cellRenderer: deploymentActionCellRenderer,
      field: "controlid",
      headerName: "",
      width: 110
    },
  ];

  return (
    <div className="fileUpload-container">
      {isLoading && (
        <div className="um-fullpage-loader-overlay">
          <MotifProgressLoader show variant="default" />
        </div>
      )}
      <div className="page-title-wrap">
        <h3>User Management</h3>
       <div >
          {activeTab === "admins" ? (
            <MotifButton
              onClick={handleOpenAdminModal}
              size="medium"
              type="button"
              className="add-admin-button"
              variant="primary"
            >
              + Add Admin
            </MotifButton>
          ) : activeTab === "deploymentTeam" ? (
            <MotifButton
              onClick={handleOpenMemberModal}
              size="medium"
              type="button"
              className="add-user-button"
              variant="primary"
            >
              + Add User
            </MotifButton>
          ) : (
            <MotifButton
              onClick={handleOpenModal}
              size="medium"
              type="button"
              variant="primary"
              className="add-user-button"
              disabled={userRole === PARTNER || userRole === USER}
            >
              + Add User
            </MotifButton>
          )}
        </div>
        <div>
          {isModalOpen && (
            <div className="modal">
              <div className="modal-contents">
                <span className="close" onClick={handleCloseModal}>
                  &times;
                </span>
                <form onSubmit={handleSubmit}>
                  <>
                    <div className="first-step-user">
                      <img
                        loading="lazy"
                        src={require("../../../src/common/images/add-user.png")}
                       className="add-modal-img"
                      />
                      <h4 className="modal-heading">Add User</h4>
                      <div className="field">
                        <MotifLabel
                          aria-label="email"
                          htmlFor="email"
                          className="motif-label"
                        >
                          Email <img  loading="lazy" src={require("../../../src/common/images/asterisk.png")} alt=""   className="mandatory-icon" />
                        </MotifLabel>
                        <MotifFormField className="motif-input">
                          <MotifInput
                            aria-label="email"
                            id="email" 
                            onInput={onEmailChange}   
                            onChange={onEmailChange}
                            onBlur={onEmailChange}
                            placeholder="Enter Email"
                            type="email"
                            autoComplete="off"
                            value={email}
                          />
                        </MotifFormField>
                        {email && !email.includes("ey.com") && (
                          <MotifErrorMessage id="select-error-reactive">
                            Please enter a valid ey address.
                          </MotifErrorMessage>
                        )}
                      </div>
                      <div className="field">
                        <MotifLabel
                          aria-label="userName"
                          htmlFor="userName"
                          className="motif-label"
                        >
                          Name <img loading="lazy" src={require("../../../src/common/images/asterisk.png")} alt=""   className="mandatory-icon"/>
                        </MotifLabel>
                        <MotifFormField
                          aria-label="userName"
                          role="group"
                          className="motif-input"
                        >
                          <MotifInput
                            aria-label="userName"
                            id="userName"
                            onChange={onUserNameClick}
                            placeholder="Enter Name"
                            value={userName}
                            disabled={UserExist}
                          />
                          <div className="separator" />
                        </MotifFormField>
                      </div>
                      <div className="field">
                        <MotifLabel id="userRoleId">Access Type <img loading="lazy" src={require("../../../src/common/images/asterisk.png")} alt=""   className="mandatory-icon"/></MotifLabel>
                        {accessTypeList?.length > 0 && (
                          <MotifFormField className="motif-input">
                            <MotifSelect
                              ariaLabelledBy="userRoleId"
                              onChange={onUserRoleIdClick}
                              placeholder="Select Access Type"
                              value={userRoleId}
                              visibleOptions={3}
                            >
                              {accessTypeList?.map((type) => {
                                return (
                                  <MotifOption value={type.roleId}>
                                    {type.roleName}
                                  </MotifOption>
                                );
                              })}
                            </MotifSelect>
                          </MotifFormField>
                        )}
                      </div>
                      <DialogActions>
                        <MotifButton
                          onClick={handleCloseModal}
                          size="medium"
                          type="button"
                          variant="secondary"
                        >
                          Cancel
                        </MotifButton>
                        {
                          <MotifButton
                            onClick={onAddUserClick}
                            size="medium"
                            type="button"
                            disabled={
                              !(
                                email.includes("ey.com") &&
                                userName &&
                                userRoleId
                              )
                            }
                          >
                            Confirm
                          </MotifButton>
                        }
                      </DialogActions>
                    </div>
                  </>
                </form>
              </div>
            </div>
          )}
          {isMemberModalOpen && (
            <div className="modal">
              <div className="modal-contents">
                <span className="close" onClick={handleCloseMemberModal}>
                  &times;
                </span>
                <form onSubmit={handleSubmit}>
                  <>
                    <div className="first-step-user">
                      <img
                        loading="lazy"
                        src={require("../../../src/common/images/add-user.png")}
                        className="add-modal-img"
                      />
                      <h4 className="modal-heading">Add Member</h4>
                      <div className="field">
                        <MotifLabel
                          aria-label="email"
                          htmlFor="memberEmail"
                          className="motif-label"
                        >
                          Email <img loading="lazy" src={require("../../../src/common/images/asterisk.png")} alt="" className="mandatory-icon" />
                        </MotifLabel>
                        <MotifFormField className="motif-input">
                          <MotifInput
                            aria-label="email"
                            id="memberEmail"
                            onInput={onEmailChange}
                            onChange={onEmailChange}
                            onBlur={onEmailChange}
                            placeholder="Enter Email"
                            type="email"
                            autoComplete="off"
                            value={email}
                          />
                        </MotifFormField>
                        {email && !email.includes("ey.com") && (
                          <MotifErrorMessage id="member-email-error">
                            Please enter a valid ey address.
                          </MotifErrorMessage>
                        )}
                      </div>
                      <div className="field">
                        <MotifLabel
                          aria-label="userName"
                          htmlFor="memberUserName"
                          className="motif-label"
                        >
                          Name <img loading="lazy" src={require("../../../src/common/images/asterisk.png")} alt="" className="mandatory-icon" />
                        </MotifLabel>
                        <MotifFormField
                          aria-label="userName"
                          role="group"
                          className="motif-input"
                        >
                          <MotifInput
                            aria-label="userName"
                            id="memberUserName"
                            onChange={onUserNameClick}
                            placeholder="Enter Name"
                            value={userName}
                          />
                          <div className="separator" />
                        </MotifFormField>
                      </div>
                      <DialogActions>
                        <MotifButton
                          onClick={handleCloseMemberModal}
                          size="medium"
                          type="button"
                          variant="secondary"
                        >
                          Cancel
                        </MotifButton>
                        <MotifButton
                          onClick={onAddMemberClick}
                          size="medium"
                          type="button"
                          disabled={!(email.includes("ey.com") && userName)}
                        >
                          Confirm
                        </MotifButton>
                      </DialogActions>
                    </div>
                  </>
                </form>
              </div>
            </div>
          )}
          {showSuccessAddToast && (
            <MotifToast variant="success" className="motif-toast-container" onClose={()=> setShowSuccessAddToast(false)}>
              <div className="result">{`Record added successfully`}</div>
            </MotifToast>
          )}
          {showSuccessEditToast && (
            <MotifToast variant="success" className="motif-toast-container" onClose={()=> setShowSuccessEditToast(false)}>
              <div className="result">{`Record Updated successfully`}</div>
            </MotifToast>
          )}
          {showSuccessDeleteToast && (
            <MotifToast variant="success" className="motif-toast-container" onClose={()=> setShowSuccessDeleteToast(false)}>
              <div className="result">{`Record Deleted successfully`}</div>
            </MotifToast>
          )}
          {showExistingUserToast && (
            <MotifToast variant="error" className="motif-toast-container" onClose={()=> setShowExistingUserToast(false)}>
              <div className="result">{`User Email Already Exist`}</div>
            </MotifToast>
          )}
          {showErrorToast && (
            <div className="motif-toast-container">
              <MotifToast variant="error" onClose={()=> setShowErrorToast(false)}>
                <div className="result">
                  {`Something went wrong. Please try again later.`}
                </div>
              </MotifToast>
            </div>
          )}
          <div className="tabbed-interface">
            <div className="tabs">
              <button
                className={`tab ${activeTab === "activeUsers" ? "active" : ""}`}
                onClick={() => setActiveTab("activeUsers")}
              >
                Active Users
              </button>
              <button
                className={`tab ${activeTab === "allRecords" ? "active" : ""}`}
                onClick={() => setActiveTab("allRecords")}
              >
                View All Records
              </button>
                <button
              className={`tab ${activeTab === "admins" ? "active" : ""}`}
              onClick={() => setActiveTab("admins")}
            >
              Admins
            </button>
                <button
              className={`tab ${activeTab === "deploymentTeam" ? "active" : ""}`}
              onClick={() => setActiveTab("deploymentTeam")}
            >
              Deployment Team
            </button>
            </div>
          </div>

          <div className="tab-content">
            {activeTab === "activeUsers" && (
              <div>
                {/* Content for Active Users */}
                <div
                  className={`backdrop ${isModalOpen ? "active" : ""}`}
                ></div>
                {viewActiveUsers && (
                  <div className="grid-user-wrapper">
                    <TableHeader
                      onFilterTextBoxChanged={onFilterTextBoxChanged}
                      searchValue={searchValue}
                      navigation={navigation}
                      tabName="activeUsers"
                    />
                    <div className="grid-container">
                      <div className={"ag-theme-quartz grid-container-inner"}>
                          <MotifTable
                            className="user-table"
                            columnDefs={columnDefs}
                            variant="default"
                            description="Descriptive text that describes your page or content."
                            name="Default"
                            pagination
                            paginationPageSize={10}
                            paginationPageSizeSelector={[3, 4, 5]}
                            rowData={viewActiveUsers}
                            zebra={false}
                          />
                            </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {activeTab === "allRecords" && (
              <div>
                {/* Content for View All Records */}
                <div
                  className={`backdrop ${isModalOpen ? "active" : ""}`}
                ></div>
                {viewAllRecords && (
                  <div className="grid-user-wrapper">
                    <TableHeader
                      onFilterTextBoxChanged={onFilterTextBoxChanged}
                      searchValue={searchValue}
                      navigation={navigation}
                    />
                    <div className="grid-container">
                      <div className={"ag-theme-quartz grid-container-inner"}>
                          <MotifTable
                            columnDefs={ViewRecordcolumnDefs}
                            variant="alt"
                            description="Descriptive text that describes your page or content."
                            name="Default"
                            pagination
                            paginationPageSize={10}
                            paginationPageSizeSelector={[3, 4, 5]}
                            rowData={viewAllRecords}
                            zebra={false}
                            
                          />
                        <Dialog
                          onClose={onEditModalClose}
                          open={isEditModalOpen}
                          className="admin-dialog"
                        >
                          <DialogTitle>
                            <img
                              loading="lazy" src={require("../../../src/common/images/update_icon.png")}
                            />
                            <div className="heading">{`Update Details`}</div>
                          </DialogTitle>

                          <IconButton
                            onClick={onEditModalClose}
                            sx={{
                              position: "absolute",
                              right: 8,
                              top: 8,
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Dialog>
                        <Dialog
                          onClose={onModalClose}
                          open={showModal}
                          className="admin-dialog"
                        >
                          <IconButton
                            onClick={onModalClose}
                            sx={{
                              position: "absolute",
                              right: 8,
                              top: 8,
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Dialog>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            {activeTab === "admins" && (
                            <div>
                              <div className="grid-user-wrapper">
                                 <TableHeader
                      onFilterTextBoxChanged={onFilterTextBoxChanged}
                      searchValue={searchValue}
                      navigation={navigation}
                      tabName="activeUsers"
                    />
                                <div className="grid-container">
                                  <div className={"ag-theme-quartz grid-container-inner"}>
                                    <MotifTable
                                      columnDefs={adminColumnDefs}
                                      variant="default"
                                      description="Descriptive text that describes your page or content."
                                      name="Default"
                                      pagination
                                      paginationPageSize={10}
                                      paginationPageSizeSelector={[3, 4, 5]}
                                      rowData={viewAdminRecords}
                                      zebra={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
            {activeTab === "deploymentTeam" && (
                            <div>
                              <div className="grid-user-wrapper">
                                 <TableHeader
                      onFilterTextBoxChanged={onFilterTextBoxChanged}
                      searchValue={searchValue}
                      navigation={navigation}
                      tabName="deploymentTeam"
                    />
                                <div className="grid-container">
                                  <div className={"ag-theme-quartz grid-container-inner"}>
                                    <MotifTable
                                      columnDefs={deploymentColumnDefs}
                                      variant="default"
                                      description="Descriptive text that describes your page or content."
                                      name="Default"
                                      pagination
                                      paginationPageSize={10}
                                      paginationPageSizeSelector={[3, 4, 5]}
                                      rowData={viewDeploymentTeamRecords}
                                      zebra={false}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                              <Dialog
                          onClose={onEditModalClose}
                          open={isEditModalOpen}
                          className="update-dialog"
                        >
                          <DialogTitle>
                            <img
                              loading="lazy"
                              src={require("../../../src/common/images/group 1.png")}
                              className="update-dialog-img"
                            />
                            <div className="heading">{`Edit Access`}</div>
                          </DialogTitle>
                          <DialogContent className="modal-content">
                            <div className="first-step-user">
                              <div className="field">
                                <MotifLabel
                                  aria-label="userName"
                                  htmlFor="userName"
                                  className="motif-label"
                                >
                                  Name
                                </MotifLabel>
                                <MotifFormField
                                  className="motif-input"
                                  aria-label="userName"
                                  role="group"
                                >
                                  <div
                                    id="userName"
                                    className="disabled-input"
                                    aria-disabled="true"
                                  >
                                    {userName ? userName : ""}
                                  </div>
                                </MotifFormField>
                              </div>
                              <div className="field">
                                <MotifLabel
                                  aria-label="email"
                                  htmlFor="email"
                                  className="motif-label"
                                >
                                  Email
                                </MotifLabel>
                                <MotifFormField className="motif-input">
                                  <div
                                    className="disabled-input"
                                    aria-disabled="true"
                                  >
                                    {email ? email : "Enter Email"}
                                  </div>
                                </MotifFormField>
                              </div>
                              <div className="field">
                                <MotifLabel id="userRoleId">
                                  Access Type <img loading="lazy" src={require("../../../src/common/images/asterisk.png")} alt=""   className="mandatory-icon" />
                                </MotifLabel>
                                {accessTypeList?.length > 0 && (
                                  <MotifFormField className="motif-input">
                                    <MotifSelect
                                      ariaLabelledBy="userRoleId"
                                      onChange={onUserRoleIdClick}
                                      placeholder="Select Access Type"
                                      value={userRoleId}
                                      visibleOptions={3}
                                    >
                                      {accessTypeList?.map((type) => {
                                        return (
                                          <MotifOption value={type.roleId} key={type.roleId}>
                                            {type.roleName}
                                          </MotifOption>
                                        );
                                      })}
                                    </MotifSelect>
                                  </MotifFormField>
                                )}
                              </div>
                            </div>
                          </DialogContent>
                          <DialogActions>
                            <MotifButton
                              onClick={onEditModalClose}
                              size="medium"
                              type="button"
                              variant="secondary"
                            >
                              Cancel
                            </MotifButton>
                            {
                              <MotifButton
                                onClick={onConfirmEditClick}
                                size="medium"
                                type="button"
                                disabled={!(userName && userRoleId && email)}
                              >
                                Confirm
                              </MotifButton>
                            }
                          </DialogActions>

                          <IconButton
                            onClick={onEditModalClose}
                            sx={{
                              position: "absolute",
                              right: 8,
                              top: 8,
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Dialog>
                        <Dialog
                          onClose={onDeleteModalClose}
                          open={isDeleteModalOpen}
                          className="update-dialog-delete"
                        >
                          <DialogTitle>
                            <img
                              loading="lazy"
                              src={require("../../../src/common/images/warning-triangle.png")}
                            />
                            <div className="heading">{`Delete User`}</div>
                          </DialogTitle>
                          <DialogContent>
                            <div className="field">
                              <MotifLabel
                                aria-label="userName"
                                htmlFor="userName"
                                className="motif-label"
                              >
                                Name
                              </MotifLabel>
                              <MotifFormField
                                className="motif-input"
                                aria-label="userName"
                                role="group"
                              >
                                <div
                                  id="userName"
                                  className="disabled-input"
                                  aria-disabled="true"
                                >
                                  {userName ? userName : ""}
                                </div>
                              </MotifFormField>
                            </div>
                            <div className="field">
                              <MotifLabel
                                aria-label="deleteDescription"
                                htmlFor="input"
                                className="motif-label"
                              >
                                <div>
                                   Comments               
                                </div>
                              </MotifLabel>
                              <MotifFormField
                                aria-label="deleteDescription"
                                role="group"
                              >
                                <textarea
                                  aria-label="deleteDescription"
                                  id="deleteDescription"
                                  onChange={onDeleteDescriptionClick}
                                  value={deleteDescription}
                                  className="motif-textarea-deleteFieldBox"
                                  maxLength={wordLimit} // This enforces the character limit
                                ></textarea>
                                <div className="character-count">
                                  {wordCount} / {wordLimit}
                                </div>
                              </MotifFormField>
                            </div>
                          </DialogContent>
                          <DialogActions className="motifButton">
                            <MotifButton
                              onClick={onDeleteModalClose}
                              size="medium"
                              type="button"
                              variant="secondary"
                            >
                              Cancel
                            </MotifButton>
                            {
                              <MotifButton
                                onClick={
                                  activeTab === "deploymentTeam"
                                    ? onConfirmDeploymentDeleteClick
                                    : activeTab !== "admins"
                                    ? onConfirmDeleteClick
                                    : onConfirmAdminDeleteClick
                                }
                                size="medium"
                                type="button"
                              >
                                Confirm
                              </MotifButton>
                            }
                          </DialogActions>

                          <IconButton
                            onClick={onDeleteModalClose}
                            sx={{
                              position: "absolute",
                              right: 8,
                              top: 8,
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Dialog>
                        <Dialog
                          onClose={onModalClose}
                          open={showModal}
                          className="admin-dialog"
                        >
                          <IconButton
                            onClick={onModalClose}
                            sx={{
                              position: "absolute",
                              right: 8,
                              top: 8,
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Dialog>
              
          </div>
        </div>
      </div>
    </div>
  );
};
